export default {
  page: {
    title: 'Agrupador de palavras',
    subtitle: 'Ferramentas',
  },
  card: {
    title: 'Agrupador de palavras',
  },
  form: {
    wordsPerGroup: {
      label: 'Palavras',
      placeholder: 'Quantidade de palavras por grupo',
    },
    groupsPerMagazine: {
      label: 'Grupos',
      placeholder: 'Quantidade de grupos por revistas',
    },
    totalMagazines: {
      label: 'Revistas',
      placeholder: 'Quantidade de revistas',
    },
    wordsList: {
      label: 'Lista de Palavras',
    },
    totalWords: {
      label: 'Total de palavras:',
    },
    magazine: {
      label: 'Revista',
    },
    group: {
      label: 'Grupo',
    },
  },
  button: {
    shuffle: 'Embaralhar lista de palavras',
    generate: 'Gerar grupos de palavras',
    copyMagazine: 'Copiar palavras da revista',
    copyWords: 'Copiar palavras',
  },
  alert: {
    shuffled: 'Lista embaralhada com sucesso',
    generated: 'Grupos gerados com sucesso',
    insufficientWords:
      'Falta {count} palavra para formar os grupos | Faltam {count} palavras para formar os grupos',
  },
};
